import React from 'react';
import { Button, Grid } from '../../common';
import StandardModal from '../../common/modals/StandardModal';
import PortOpeningRule from '../../../models/entities/PortOpeningRule';
import { PortOpeningRequestsDirection } from '../../../models/enums/POR/PortOpeningRequestsDirection';
import ImplementedRulesTable from './ImplementedRulesTable';
import './ImplementedRulesModal.css';
import { RuleOperation } from '../../../models/enums/POR/RuleOperation';

interface ImplementedRulesModalProps {
	direction: PortOpeningRequestsDirection;
    rules: PortOpeningRule[];
	onSuccess: (rules: PortOpeningRule[]) => any;
	onCancel: (...args: any[]) => any;
	visible: boolean;
	alreadySelected: string[]
}

interface ImplementedRulesModalState {
    selectedRules: PortOpeningRule[];
}

export default class ImplementedRulesModal
	extends React.Component<ImplementedRulesModalProps, ImplementedRulesModalState> {

	constructor(props) {
		super(props);
		this.setState({
			selectedRules: []
		});
	}

	handleOnChange = (rules: PortOpeningRule[]) => {
		this.setState({ selectedRules: rules });
	};
	
	handleOnSuccess = () => {
		const rules = this.state?.selectedRules;
		rules.forEach(rule => {
			rule.operation = RuleOperation.Modify;
			rule.name = rule.azureName;
		});
		this.setState({ selectedRules: [] });
		this.props.onSuccess(rules);
	};
	
	handleOnCancel = () => {
		this.setState({ selectedRules: [] });
		this.props.onCancel();
	};

	disableAddRulesButton(): boolean {
		return this.state?.selectedRules == null || this.state.selectedRules?.length === 0;
	}
	
	render() {
		return (
			<StandardModal
				show={this.props.visible}
				onDismiss={this.handleOnCancel}
				title="Add rules to the request"
				optionalClass="autoOverflowModal"
				size="em-c-modal--large"
				footer={
					<Grid variant="halves">
						<Grid.Item>
							<Button variant="secondary" onClick={this.handleOnCancel}>
								Cancel
							</Button>
						</Grid.Item>
						<Grid.Item>
							<Button
								variant="primary"
								onClick={this.handleOnSuccess}
								disabled={this.disableAddRulesButton()}
							>
								Add Rules
							</Button>
						</Grid.Item>
					</Grid>
				}
			>
				<ImplementedRulesTable
					porDirection={this.props.direction}
					rules={this.props.rules}
					selectedRules={this.state?.selectedRules || []}
					onChange={this.handleOnChange}
				/>
			</StandardModal>
		);
	}
}